<template>
  <footer>
      <div class="por_container">
        <div class="container">
          <div class="link"><a href="http://beian.mps.gov.cn/#/query/webSearch" target="_blank" rel="noopener noreferrer">川公网安备51010602001543号</a></div>
          <div class="link"><a href="https://beian.miit.gov.cn/#/Integrated/index" target="_blank">蜀ICP备11006773号-11</a></div>
        </div>
      </div>
    </footer>
</template>

<script>
export default {}
</script>

<style lang="scss" scoped>
footer {
  background-color: #313131;
  height: var(--foot-height);
  display: flex;
  color: rgba($color: #fff, $alpha: .9);
  

  .container {
    height: 100%;
    line-height: 2;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }

  .link a {
    transition: .3s;

    &:hover {
      color: #fff;
      text-decoration: underline;
    }
  }
}
</style>